import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getEnvVariableValue } from "util/CommonUtil";

export interface IBaseUrlState {
  baseUrl: string;
}

const initialState: IBaseUrlState = {
  baseUrl: getEnvVariableValue("VITE_BASE_API_URL") ?? "",
};

const baseApiUrlSlice = createSlice({
  name: "baseApiUrl",
  initialState,
  reducers: {
    setBaseUrl: (state: IBaseUrlState, action: PayloadAction<string>) => {
      state.baseUrl = action.payload;
    },
  },
});

export const { setBaseUrl } = baseApiUrlSlice.actions;

export default baseApiUrlSlice.reducer;
